import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of, tap } from 'rxjs';
import { AuthService } from '../services/api/auth-api';
import { UserMicroservice } from '../services/api/user-api';
import { AuthDispatcherService } from '../services/local/auth/auth-dispatcher.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const userMicroservice = inject(UserMicroservice);
  const authDispatcherService = inject(AuthDispatcherService);

  if (!authService.isAuthenticated()) {
    authService.login();
    return false;
  }

  if (userMicroservice.applicationUser$.getValue() != null) {
    return true;
  }

  return userMicroservice.getSelf$().pipe(
    tap(user => authDispatcherService.publish(user)),
    map(() => true),
    catchError(() => {
      authService.logout();
      return of(false);
    })
  );
};
